import { render, staticRenderFns } from "./SelfServiceQuickActionsCard.vue?vue&type=template&id=be30a5be"
import script from "./SelfServiceQuickActionsCard.vue?vue&type=script&lang=js"
export * from "./SelfServiceQuickActionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports